export default __webpack_public_path__ + "static/media/31_tag_pet-friendly.24e137c2.svg";